import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';
import { receiveExportAwbs } from '../../store/actions/awbsAction';

import attachmentsRequestHandler from '../../api/attachmentsRemote';

import OrderAttachments from './OrderAttachments';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';

import Attachment from '../../models/Attachment';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';

interface OrderAttachmentsProps {
  number: string;
  orderId: number;
  port: string;
  gha: number;
  process: 'import' | 'export';
  receiveError: (error: ResponseError) => void;
  closeAttachments: (event:any) => void;
  updateExportAwbs: (port: string, gha: number) => void;
  refreshAwbs: boolean;
  onlyRead? : boolean;
  type: string;
};

interface OrderAttachmentsState {
  attachmentType: string;
  attachmentsList: Array<Attachment>;
  isAttachmentDeleteConfirmationOpen: boolean;
  key: string;
};

class OrderAttachmentsContainer extends Component<OrderAttachmentsProps, OrderAttachmentsState> {

  state = {
    attachmentType: 'offline_order',
    attachmentsList: [],
    isAttachmentDeleteConfirmationOpen: false,
    key: ''
  };

  componentDidMount() {
    this.loadAttachments();
  }

  componentDidUpdate(prevProps: OrderAttachmentsProps) {
    if(prevProps.orderId !== this.props.orderId) {
      this.loadAttachments();
    }
  }

  loadAttachments = ():void => {
    if(this.props.type === 'rfs') {
      attachmentsRequestHandler.loadOfflineAttachments(this.props.orderId, true).then((resp: ApiResponse<Array<Attachment>>) => {
        const result: Array<Attachment> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (result) {
          this.setState({attachmentsList: result});
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    } else {
      attachmentsRequestHandler.loadOrderAttachments(this.props.orderId).then((resp: ApiResponse<Array<Attachment>>) => {
        const result: Array<Attachment> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (result) {
          this.setState({attachmentsList: result});
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
   
  }

  changeAttachmentType = (event:any):void => {
    this.setState({attachmentType: event.target.value});
  }

  attachFile = (event:any): void => {
    if(this.props.type === 'rfs' && event.target.files[0]) {
      const formData: FormData = new FormData();
      formData.append('attachment', event.target.files[0]);
      attachmentsRequestHandler.uploadOfflineOrderFile(this.props.orderId, this.state.attachmentType, formData, true).then((resp) => this.responseHandler(resp, true));
    } else {
      if(event.target.files[0]) {
        const formData: FormData = new FormData();
        formData.append('attachment', event.target.files[0]);
        attachmentsRequestHandler.uploadOrderFile(this.props.orderId, this.state.attachmentType, formData).then((resp) => this.responseHandler(resp, true));
      }
    }
   
  }

  pasteClipboardImage = (event: any): void => {

    if (event.clipboardData.files[0] && this.props.type === 'rfs') {

      const formData: FormData = new FormData();
      formData.append('attachment', event.clipboardData.files[0]);

      attachmentsRequestHandler.uploadOfflineOrderFile(this.props.orderId, this.state.attachmentType, formData).then((resp) => this.responseHandler(resp, true));
    } else {
      if (event.clipboardData.files[0]) {

        const formData: FormData = new FormData();
        formData.append('attachment', event.clipboardData.files[0]);
  
        attachmentsRequestHandler.uploadOrderFile(this.props.orderId, this.state.attachmentType, formData).then((resp) => this.responseHandler(resp, true));  
      }
    }
  }

  handleDelete = (key:string): void => {
    this.setState({ isAttachmentDeleteConfirmationOpen: true, key });
  };

  deleteAttachment = (): void => {
    if(this.props.type === 'rfs') {
      attachmentsRequestHandler.deleteOfflineAttachment(this.state.key).then((resp: ApiResponse<boolean>) => {
        const result: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;
  
        if (result) {
          this.loadAttachments();
          this.setState({isAttachmentDeleteConfirmationOpen: false});
          this.refreshAwbs();
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    } else {
      attachmentsRequestHandler.deleteAttachment(this.state.key).then((resp: ApiResponse<boolean>) => {
        const result: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;
  
        if (result) {
          this.loadAttachments();
          this.setState({isAttachmentDeleteConfirmationOpen: false});
          this.refreshAwbs();
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  };

  changeAccessibility = (attachmentItem: Attachment) => {
    if(this.props.type === 'rfs') {
      attachmentsRequestHandler.changeOrderAttachmentAccessibility(attachmentItem.attachment_key, attachmentItem.public).then(this.responseHandler);
    } else {
      attachmentsRequestHandler.changeAttachmentAccessibility(attachmentItem.attachment_key, attachmentItem.public, attachmentItem.attachment_type).then(this.responseHandler);
    }
  };

  refreshAwbs = (): void => {
    if (this.props.refreshAwbs) {
      this.props.updateExportAwbs(this.props.port, this.props.gha);
    }
  }

  responseHandler = (resp: ApiResponse<boolean>, doUpdateExportAwbs?: boolean): void => {

    const result: boolean | undefined = resp.success;
    const error: ResponseError | undefined = resp.error;

    if (result) {
      this.loadAttachments();

      if (doUpdateExportAwbs) {
        this.refreshAwbs();
      }
    }

    if (error) {
      this.props.receiveError(error);
    };
  }

  render() {
    return (
      <Fragment>
        <OrderAttachments
          closeAttachments={ this.props.closeAttachments } 
          number = { this.props.number }
          process = { this.props.process }
          attachmentType = { this.state.attachmentType }
          changeAttachmentType = { this.changeAttachmentType }
          attachFile = { this.attachFile }
          attachmentsList = { this.state.attachmentsList }
          handleDelete = { this.handleDelete }
          changeAccessibility = { this.changeAccessibility }
          onlyRead={ this.props.onlyRead }
          pasteClipboardImage={ this.pasteClipboardImage }
          type={ this.props.type }
        />
        { this.state.isAttachmentDeleteConfirmationOpen && 
          <ConfirmationDialog
            open={ this.state.isAttachmentDeleteConfirmationOpen }
            close={ () => { this.setState({ isAttachmentDeleteConfirmationOpen: false }) } }
            title='Delete Confirmation'
            text='Your file will be permanently removed. To confirm deletion click on the “Delete” button.'
            textConfirm='delete'
            confirm={ this.deleteAttachment } 
            showCloseIcon={ true }
          />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any, props: any) => {
  return {
    port: state.originPort,
    gha: state.originGhaId,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    updateExportAwbs: (port: string, gha: number) => dispatch(receiveExportAwbs(port, gha))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderAttachmentsContainer);